import { gpHome } from '../app';
import { AccountsService } from '../services/accounts-service';
import { ILogglyService } from '../../app-common/services/jsloggly-service';

    interface ICreatePasswordScope extends ng.IScope {

        isCreating: boolean;
        isResetting: boolean;

        showInputs(): boolean;

        confirmationSuccessful: boolean;
        confirmationResending: boolean;
        confirmationResent: boolean;
        confirmationResentError: boolean;
        confirmationError: {
            message: string;
        } | null;
        confirming: boolean;

        registration: {
            email: string;
            password: string;
            confirmPassword: string;
        }

        createPassword(): void;
        resendConfirmation(): void;
    }

gpHome.controller('createPasswordController',
        ['$scope', 'accountsService', '$routeParams', 'gpLogglyService',
            function ($scope: ICreatePasswordScope, accountsService: AccountsService, $routeParams: ng.route.IRouteParamsService, gpLogglyService: ILogglyService) {

                let userId = $routeParams['userId'];
                let email = $routeParams['email'];
                let code = $routeParams['code'];
                let resetting = $routeParams['reset'];

                if (resetting) {
                    $scope.isCreating = false;
                    $scope.isResetting = true;
                } else {
                    $scope.isCreating = true;
                    $scope.isResetting = false;
                }

                $scope.showInputs = () => {
                    //The != null check is intentional as it could be undefined as well
                    return ($scope.confirming || $scope.confirmationError != null) && !$scope.confirmationSuccessful;
                };

                $scope.registration = {
                    email: email,
                    confirmPassword: "",
                    password: "",
                };

                $scope.confirming = true;

                $scope.resendConfirmation = () => {

                    let req = accountsService.resendEmail(userId);

                    req.then(() => {
                        $scope.confirmationError = { message: "Confirmation Resent. Please Check your email" };
                    });

                    req.catch(() => {
                        $scope.confirmationError = { message: "There was an error sending the email. Please contact support." };
                    });

                };

                $scope.createPassword = () => {

                    $scope.confirmationError = null;

                    if (!$scope.registration || !$scope.registration.password || !$scope.registration.confirmPassword) {

                        $scope.confirmationError = { message: "Please type a password" };

                    } else if ($scope.registration.password === $scope.registration.confirmPassword) {
                        let req: ng.IPromise<any>;


                        if ($scope.isCreating) {
                            req = accountsService.confirmEmailCreatePassword(userId, code, $scope.registration.password);
                        } else {
                            req = accountsService.changePassword({ userId: userId, verificationCode: code, newPassword: $scope.registration.password });
                        }

                        if (req) {
                            req.then(value => $scope.confirmationSuccessful = true)
                            req.catch(value => $scope.confirmationError = parseError(value, gpLogglyService));
                        }
                    } else {
                        $scope.confirmationError = { message: "Passwords do not match" };

                    }
                }
            }]);

function parseError(value: any, gpLogglyService: ILogglyService): { message: string } {
    gpLogglyService.error("Error creating password Error {Error}", [value], { ClientContext: 'createPasswordController' });

    let result = {
        message: ""
    };

    if (value) {
        if (value.modelState) {
            result.message = value.modelState[""].join("; ");
        } else if (value.exceptionMessage) {
            result.message = value.exceptionMessage;
        } else {
            result.message = "An error has occurred";
        }
    } else {
        result.message = "An unknown has occurred";
    }

    return result;
}
